import { useParams, useLocation } from "react-router";
import CompletedProcess, { CompletedProcessType } from "./CompletedProcess";

// Wrapper component to handle route parameters
const CompletedProcessWrapper = () => {
  const location = useLocation();
  const { uuid, transactionUuid, code } = location.state || {};
  const { type } = useParams<{ type: string, uuid: string, transactionUuid: string }>();
  const processType: CompletedProcessType = (
    type === 'recovery' || type === 'pin-change' || type === 'processing' || type === 'under-review' || type === 'processing-reviewed'
  ) ? type : 'recovery';

  return <CompletedProcess type={processType} uuid={uuid} transactionUuid={transactionUuid} code={code} />;
};

export default CompletedProcessWrapper;